import { css } from 'emotion';

export default {
  wrapper: css({
    height: '70vh',
    display: 'grid',
    placeItems: 'center',
  }),
};
